webpackJsonp([201471480251666],{

/***/ 435:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Common Energy"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/drs/"},"frontmatter":{"title":"DRS"}}}]}},"pathContext":{"tag":"Drs"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-drs-485ecce253e6222d3cda.js